import React, { useState } from "react";
import { Col, Row } from "antd";
import { useParams } from "react-router-dom";

import useMapData from "../../utils/useMapData";

import { ModalOverlay } from "../Modal/Modal";
import { VerticalText } from "../../StyledCmp";

// import virtualTourImage from "../assets/imageOne.webp";
import playBtn from "../../assets/PlayButton.svg";

const VirtualSiteTour = React.forwardRef((props, ref) => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const [organizeVisit, setOrganizeVisit] = useState(false);

  const toggleOrganizeVisit = () => {
    setOrganizeVisit(prevState => !prevState);
  };

  let virtualTourImage = resultList.carouselImages
    ? resultList?.carouselImages[0]
    : null;

  return (
    <>
      <Row ref={ref} className="virtual_tour_wrapper">
        <div id="horizontal_text">
          <h1 style={{ color: resultList?.themeColor }}>Virtual Site Tour</h1>
        </div>
        <Col lg={20} className="tour_video">
          <img src={virtualTourImage} alt="virtual_tour" />
          <div className="virtualTour_overlay">
            <div
              className="virtualTour_overlay_text"
              onClick={toggleOrganizeVisit}
            >
              <img width={100} src={playBtn} alt="virtual_tour" />
              <div className="virtualTour_overlay_text-desktop">
                <h3>Virtual Tour</h3>
                <p>
                  {resultList?.projectName} At {resultList?.locationName}
                </p>
              </div>
            </div>
          </div>
          <p onClick={toggleOrganizeVisit} id="outflow_text">
            {resultList?.projectName} At {resultList?.locationName}
          </p>
        </Col>
        <Col lg={1}>
          <div className="vertical_text">
            <VerticalText>Virtual Site Tour</VerticalText>
          </div>
        </Col>
      </Row>
      {organizeVisit && (
        <ModalOverlay
          isModalVisible={organizeVisit}
          handleModalVisibility={toggleOrganizeVisit}
          title={"Virtual Site Visit"}
          btnText="Start Tour"
          actionType="virtual-site-tour"
        />
      )}
    </>
  );
});

export default VirtualSiteTour;
